import type * as DashboardTypes from '../dashboard/dashboardTypes';

enum SearchActionTypes {
	SEARCH_GET_SEARCHES_REQUEST = 'search/GET_SEARCHES_REQUEST',
	SEARCH_GET_SEARCHES_SUCCESS = 'search/GET_SEARCHES_SUCCESS',
	SEARCH_GET_SEARCHES_FAILURE = 'search/GET_SEARCHES_FAILURE',

	SEARCH_ADD_SEARCH_REQUEST = 'search/SEARCH_ADD_SEARCH_REQUEST',
	SEARCH_ADD_SEARCH_SUCCESS = 'search/SEARCH_ADD_SEARCH_SUCCESS',
	SEARCH_ADD_SEARCH_FAILURE = 'search/SEARCH_ADD_SEARCH_FAILURE',
	SEARCH_ADD_SEARCH_RESET = 'search/SEARCH_ADD_SEARCH_RESET',

	SEARCH_EDIT_SEARCH_REQUEST = 'search/SEARCH_EDIT_SEARCH_REQUEST',
	SEARCH_EDIT_SEARCH_SUCCESS = 'search/SEARCH_EDIT_SEARCH_SUCCESS',
	SEARCH_EDIT_SEARCH_FAILURE = 'search/SEARCH_EDIT_SEARCH_FAILURE',

	SEARCH_REMOVE_SEARCH_REQUEST = 'search/SEARCH_REMOVE_SEARCH_REQUEST',
	SEARCH_REMOVE_SEARCH_SUCCESS = 'search/SEARCH_REMOVE_SEARCH_SUCCESS',
	SEARCH_REMOVE_SEARCH_FAILURE = 'search/SEARCH_REMOVE_SEARCH_FAILURE',
	SEARCH_RESET_SAVE_STATUS = 'SEARCH_RESET_SAVE_STATUS'
}

interface SearchLocation {
	id: string;
	coordinates: number[];
}

interface Search {
	id?: string;

	name?: string;

	location?: SearchLocation;

	locationId?: string;

	listId?: string;

	params?: DashboardTypes.Search[];

	filters?: DashboardTypes.BusinessQuery;
}

interface SearchAction {
	type: SearchActionTypes;

	payload?: any;

	error?: Error;
}

export { SearchActionTypes, SearchAction, Search, SearchLocation };
